const FormCol = ({ children }) => {
  return <div className="col">{children}</div>;
};

export default FormCol;
